// extracted by mini-css-extract-plugin
export default {"amount":"AmountWithIcon_amount__RXYOf","icon":"AmountWithIcon_icon__eI9lM"};